import { connect } from 'react-redux'
import {
  getFormSyncErrors,
  getFormAsyncErrors,
  change,
  untouch,
  touch,
  registerField,
} from 'redux-form'

import { checkoutAddressLookup } from 'routes/Checkout/checkoutActions'

import { Address } from '../Address'

function mapStateToProps(state, ownProps) {
  return {
    addressesPending: state.pending.get('CHECKOUT_ADDRESSES_RECEIVE', false),
    formValues: ownProps.formValues,
    formErrors: {
      ...getFormSyncErrors(ownProps.formName)(state),
      ...getFormAsyncErrors(ownProps.formName)(state),
    },
    sectionName: ownProps.sectionName,
  }
}

const BillingAddressContainer = connect(mapStateToProps, {
  checkoutAddressLookup,
  change,
  untouch,
  touch,
  registerField,
})(Address)

export { BillingAddressContainer }
